/*import dailyLivingImg from "../Images/Services/daily-living.jpg";
import communityImg from "../Images/Services/community.jpg";
import developmentImg from "../Images/Services/development.jpg";
import advocacyImg from "../Images/Services/advocacy.jpg";*/


const ServiceData = [
  /*{
    id: 'Adaptive Skills Training',
    term: "Adaptive Skills Training",
    definition:
      "Adaptive skills training helps individuals with intellectual disabilities develop essential life skills such as communication, self-care, and social interaction. These skills are crucial for achieving independence and improving quality of life.",
    bulletsTitle: [
        "AST for children include:",
        "In addition to the goals listed, we also offer our AST adult consumers opportunities for:",
    ],
    bulletsA: [
      "Behavior Support",
      "Communication",
      "Community Resources",
      "Household Chores",
      "IEP Advocacy",
      "Personal Nutrition",
      "Safety and Survival",
      "Self-Care Skills",
      "Social Skills Development",
      "Toilet Training"

    ],
    bulletsB: [
        "College Support - on college campus",
        "Community Support - community classes such as computer, fitness, and art",
        "in lieu of day program - client and family choice, a 100% personalized day program"
    ],
    image: "",
  },*/
  {
    id: "Independent Living Skills Training",
    term: "Independent Living Skills Training",
    definition:
      "Independent living skills training helps adults with intellectual disabilities learn essential life skills needed for a life of independent living",
    bulletsTitle: [
        "Training Areas:"
    ],
    bulletsA: [
      "Money Management",
      "Mobility and Travel Training",
      "Shopping",
      "Home Cleaning Skills",
      "DMV Written Examination",
      "Self-Advocacy",
      "Community Resources",
      "Home and Community Safety",
      "Personal Hygiene and Grooming Skills",
      "Meal Planning, Preparation and Nutrition",
      "Social and Recreation"
    ],
    /*bulletsB: [
        ,
        "Social Development",
    ],*/
    image: "",
  },
  /*{
    id: "Supportive Living Services",
    term: "Supportive Living Services",
    definition:
      "Supportive living services provide assistance and support to individuals with intellectual disabilities to help them live independently in their communities. These services may include housing support, personal care assistance, and help with daily activities such as cooking, cleaning, and managing medications.",
    bulletsTitle: [
        "Our Supportive Living Services Program includes, but is not limited to:",
    ],
    bulletsA: [
      "Cooking and meal preparation",
      "Managing household tasks",
      "Personal hygiene and self-care",
      "Budgeting and money management",
      "Safety and emergency preparedness",
      "Transportation skills training"
    ],
    bulletsB: [
        "Providing 24 hour emergency response, if needed",
        "Recruiting, hiring and training appropriate individuals to provide direct support",
        "Facilitating Circles of Support to develop paid, unpaid and/or natural supports in the community",
        "Facilitating Self-Advocacy",
        "Developing Community Support - classes such as Computer, Fitness and Art"
    ],
    image: "",
  },
  {
    id: "Service Referral",
    term: "Service Referral",
    definition:
      "Regional Center referrals can be made by submitting a Purchase of Service (POS) to Rodgers Consulting Services, Inc. along with a completed referral form either online or via fax. Please include a current IPP and any other report which might contain pertinent information regarding the consumer's needs.",
    bulletsTitle: [
    ],
    bulletsA: [
      "Cooking and meal preparation",
      "Managing household tasks",
      "Personal hygiene and self-care",
      "Budgeting and money management",
      "Safety and emergency preparedness",
      "Transportation skills training"
    ],
    bulletsB: [
    ],
    image: "",
  }*/
];

export default ServiceData;